import React, { Component } from 'react';
import Select from 'react-select';
import NumberFormat from "react-number-format";

import { states } from '../../../_helpers/states';
import { locationsService } from "../../../_services/locations.service"
import { Form, Button, Spinner } from 'react-bootstrap';

import './style.css';

const timezones = [
  { value: "America/New_York", label: "EASTERN" },
  { value: "America/Chicago", label: "CENTRAL" },
  { value: "America/Denver", label: "MOUNTAIN" },
  { value: "America/Los_Angeles", label: "PACIFIC" }
]

export default class LocationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      timezone: "",
      phoneNumber: "",
      logo: "",
      logoName: "",
      logoPreview: "",
      saving: false,
      errors: []
    }
    this.validate = this.validate.bind(this);
    this.handleSaveLocation = this.handleSaveLocation.bind(this);
    this.encodeLogoFileAsURL = this.encodeLogoFileAsURL.bind(this);
  }

  componentDidMount() {
    if (this.props.location) {
      this.setState({ ...this.props.location });
    }
  }

  validate(e) {
    e.preventDefault();

    let errors = {};
    let phoneNumber = this.state.phoneNumber.replace(/\D/g, "");

    if (this.state.name.length === 0) {
      errors.name = "Name is required.";
    }

    if (this.state.address1.length === 0) {
      errors.address = "Address is required.";
    }

    if (this.state.city.length === 0) {
      errors.city = "City is required.";
    }

    if (this.state.state.length === 0) {
      errors.state = "State is required.";
    }

    if (this.state.zip.length === 0) {
      errors.zip = "Zipcode is required.";
    }

    if (this.state.timezone.length === 0) {
      errors.timezone = "Timezone is required.";
    }

    if (phoneNumber.length !== 10) {
      errors.phoneNumber = "Phone Number is required.";
    }

    this.setState({ errors });

    if (
      !errors.name &&
      !errors.address &&
      !errors.city &&
      !errors.state &&
      !errors.zip &&
      !errors.timezone &&
      !errors.phoneNumber &&
      !errors.Logo
    ) {
      this.handleSaveLocation();
    }
  }

  handleSaveLocation = () => {
    this.setState({ saving: true });

    const location = {
      name: this.state.name,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      zip: this.state.zip,
      timezone: this.state.timezone,
      phoneNumber: this.state.phoneNumber,
      logo: this.state.logo
    }

    if (this.props.type === "add") {
      locationsService.addLocation(location)
        .then((response) => {
          this.setState({ saving: false }, () => {
            this.props.success("Location Added");
            this.props.close();
          });
        })
        .catch(error => {
          this.setState({ saving: false });

          if (error.response) {
            alert(error.response.data.message)
          } else {
            alert("Could not add a location at this time. We're looking into it.");
          }
        });
    }
    else if (this.props.type === "edit") {
      locationsService.editLocation(location, this.state.id)
        .then((response) => {
          this.setState({ saving: false }, () => {
            this.props.success("Location Updated");
            this.props.close();
          });
        })
        .catch(error => {
          this.setState({ saving: false });

          if (error.response) {
            alert(error.response.data.message)
          } else {
            alert("Could not add a location at this time. We're looking into it.");
          }
        });
    }

  }

  encodeLogoFileAsURL(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.setState({ logoPreview: e.target.result })
    };
    reader.onloadend = () => {
      this.setState({ logo: reader.result, logoName: file.name });
    }
  }

  renderValidateMessage(field) {
    const message = this.state.errors[field];
    return (
      <div id={`${field}-error`} className="text-danger hide">
        {message}
      </div>
    );
  }

  removeLogo() {
    this.setState({ logoPreview: "", logoName: "", logo: "" })
  }

  render() {
    const selectedState = states.find((state) => {
      return state.value === this.state.state;
    });
    const selectedTimezone = timezones.find((timezone) => {
      return timezone.value === this.state.timezone;
    });

    return <div className="px-4 pt-4">
      <Form>
        <Form.Group controlId="Name">
          <div className="row">
            <div className="col-md-4">
              <Form.Label><span className="text-danger">*</span>&nbsp;Name</Form.Label>
              <Form.Control type="text" placeholder="Name" value={this.state.name}
                onChange={(e) => this.setState({ name: e.target.value })} />
              {this.renderValidateMessage("name")}

            </div>
          </div>
        </Form.Group>
        <Form.Group controlId="Addresses">
          <div className="row">
            <div className="col-md-4">
              <Form.Label><span className="text-danger">*</span>&nbsp;Address 1</Form.Label>
              <Form.Control type="text" placeholder="Address 1" value={this.state.address1}
                onChange={(e) => this.setState({ address1: e.target.value })} />
              {this.renderValidateMessage("address")}
            </div>
            <div className="col-md-4">
              <Form.Label>Address 2</Form.Label>
              <Form.Control type="text" placeholder="Address 2" value={this.state.address2}
                onChange={(e) => this.setState({ address2: e.target.value })} />
            </div>
          </div>
        </Form.Group>
        <Form.Group controlId="Location">
          <div className="row">
            <div className="col-12 col-md">
              <Form.Label><span className="text-danger">*</span>&nbsp;City</Form.Label>
              <Form.Control type="text" placeholder="City" value={this.state.city}
                onChange={(e) => this.setState({ city: e.target.value })} />
              {this.renderValidateMessage("city")}
            </div>
            <div className="col-12 col-md">
              <Form.Label><span className="text-danger">*</span>&nbsp;State</Form.Label>
              <Select options={states} placeholder="State" isClearable backspaceRemovesValue
                value={selectedState || ''}
                onChange={(selected) => {
                  selected ? this.setState({ state: selected.value }) : this.setState({ state: "" });
                }}
              />
              {this.renderValidateMessage("state")}
            </div>
            <div className="col-12 col-md">
              <Form.Label><span className="text-danger">*</span>&nbsp;Zip Code</Form.Label>
              <Form.Control type="number" placeholder="Zip Code" value={this.state.zip}
                onChange={(e) => this.setState({ zip: e.target.value })} />
              {this.renderValidateMessage("zip")}
            </div>
          </div>
        </Form.Group>
        <Form.Group controlId="Timezone">
          <div className="row">
            <div className="col-md-4" style={{ "zIndex": "99" }}>
              <Form.Label><span className="text-danger">*</span>&nbsp;Timezone</Form.Label>
              <Select isClearable options={timezones} placeholder="Timezone"
                value={selectedTimezone || ''}
                onChange={(selected) => {
                  selected ? this.setState({ timezone: selected.value }) : this.setState({ timezone: "" });
                }}
              />
              {this.renderValidateMessage("timezone")}
            </div>
          </div>
        </Form.Group>
        <Form.Group controlId="Phone">
          <div className="row">
            <div className="col-md-4">
              <Form.Label><span className="text-danger">*</span>&nbsp;Phone Number</Form.Label>
              <NumberFormat
                onValueChange={(e) => {
                  this.setState({
                    phoneNumber: e.value,
                  });
                }}
                value={this.state.phoneNumber}
                mask="_"
                name="phone"
                format="###-###-####"
                className="form-control"
                placeholder="___-___-____"
              />
              {this.renderValidateMessage("phoneNumber")}
            </div>
          </div>
        </Form.Group>
        <div className="row mt-5" >
          <div className="col-auto">
            <Button variant="primary" disabled={this.state.saving} onClick={this.validate}>
              {this.state.saving ?
                <><Spinner size="sm" animation="border"></Spinner>
                  <span>&nbsp;{this.props.type === "add" ? "Adding..." : "Updating..."}</span>
                </>
                :
                this.props.type === "add" ? "Add Location" : "Update Location"}
            </Button>
          </div>
          <div className="col-auto pl-0">
            <Button variant="primary" onClick={this.props.close}>
              Cancel
            </Button>
          </div>
        </div>
      </Form>
    </div >
  }
}
